/** Alvo externo atingido na demonstração de cinemática. */
export type TipoAlvoImpacto = 'outroVeiculo' | 'poste' | 'muro'

/** Id reservado da trajetória física do alvo externo; não é um ocupante. */
export const ID_ALVO_EXTERNO = '__alvo_externo__'

/** Id do segundo alvo externo, quando o tipo declara `impactoSecundario`. */
export const ID_ALVO_EXTERNO_SECUNDARIO = '__alvo_externo_2__'

export interface AlvoImpacto {
  id: TipoAlvoImpacto
  nome: string
  classificacao: 'colisão' | 'choque'
  descricao: string
}

export const TIPOS_ALVO_IMPACTO: readonly TipoAlvoImpacto[] = [
  'outroVeiculo',
  'poste',
  'muro',
]

export const ALVOS_IMPACTO: Record<TipoAlvoImpacto, AlvoImpacto> = {
  outroVeiculo: {
    id: 'outroVeiculo',
    nome: 'Outro veículo',
    classificacao: 'colisão',
    descricao: 'Impacto entre veículos. A cena destaca o ponto de contato e o movimento relativo.',
  },
  poste: {
    id: 'poste',
    nome: 'Poste',
    classificacao: 'choque',
    descricao: 'Impacto contra objeto fixo e estreito. A carga fica concentrada em uma área menor.',
  },
  muro: {
    id: 'muro',
    nome: 'Muro',
    classificacao: 'choque',
    descricao: 'Impacto contra objeto fixo e amplo. A frente ou lateral encontra uma superfície contínua.',
  },
}

export const alvoImpacto = (tipo: TipoAlvoImpacto): AlvoImpacto => ALVOS_IMPACTO[tipo]

